module.exports = __webpack_public_path__ + "img/icon_page7_phone.a5a8ef55.png";